import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import apontamentoReport from "./reports";
import ReportSummary from "./reports/summary";

export default class PC extends Indicador {
    static get fullName() {
        return "Profundidade de Canterização";
    }

    static get abbrev() {
        return "PC";
    }

    static get legacyApontamentoMap() {
        return {

            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    profundidadeColeta: "profundidade",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            pcintervaloAderenciaMinimoManual: "manual.intervaloMin",
            pcintervaloAderenciaMaximoManual: "manual.intervaloMax",
            pcvalorMetaManual: "manual.meta",

            pcintervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            pcintervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            pcvalorMetaMecanizado: "mecanizado.meta",

            pontosAmostradosPC: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacao: "classificacao",
                    intervalo1PC: "intervaloMin",
                    intervalo2PC: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (f(coleta.profundidade) >= f(params.intervaloMin) && f(coleta.profundidade) <= f(params.intervaloMax)) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.profundidade) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.2, 100, 104.3);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.profundidade)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        return ""
    }
}
